module.exports = __webpack_public_path__ + "img/fb.0ca4e102.png";